import React from 'react'
import { createStackNavigator } from '@react-navigation/stack'
import { useSelector } from 'react-redux'

// import { navigationOptionsDefault } from '../config/navigation'
import SignInScreen from '../screens/auth/SignInScreen'
import SignUpScreen from '../screens/auth/SignUpScreen'
import SignUpSecondScreen from '../screens/auth/SignUpSecondScreen'
// import ForgotPasswordScreen from '../screens/auth/ForgotPasswordScreen'
import OnboardingScreen from '../screens/onboarding/OnboardingScreen'
import { commonScreenOptions } from '../config/navigation'

const Stack = createStackNavigator()

type Props = {
  initialRoute: string
}

const SignedOutNavigator = () => {
  const { loggedIn, skipOnboarding } = useSelector((state) => state.user)
  const initialRoute = skipOnboarding ? 'SignIn' : 'Onboarding'

  return (
    <Stack.Navigator
      initialRouteName={initialRoute}
      screenOptions={{ ...commonScreenOptions }}
    >
      <Stack.Screen
        name="Onboarding"
        component={OnboardingScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="SignUp"
        component={SignUpScreen}
        options={{
          title: 'Code eingeben',
          animationTypeForReplace: !loggedIn ? 'pop' : 'push', // may not work due to parent stack change
        }}
      />
      <Stack.Screen
        name="SignUpSecond"
        component={SignUpSecondScreen}
        options={{ title: 'Anmeldedaten' }}
      />
      <Stack.Screen
        name="SignIn"
        component={SignInScreen}
        options={{ title: 'Anmelden' }}
      />
    </Stack.Navigator>
  )
}

export default SignedOutNavigator
